// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__19MKp","selects":"Documents_selects__1FBmS"};